import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeAbsenceTimeEnum {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
}

export type EmployeeAbsenceTimeType =
  EmployeeAbsenceTimeEnum.DAYS | EmployeeAbsenceTimeEnum.HOURS;

export const EmployeeAbsenceTimeArray = [
  EmployeeAbsenceTimeEnum.DAYS,
  EmployeeAbsenceTimeEnum.HOURS,
];

export const EmployeeAbsenceTimeInfo: QarepaEnumInformation<EmployeeAbsenceTimeEnum> =
  {
    [EmployeeAbsenceTimeEnum.DAYS]: {
      name: $localize`Días`,
    },
    [EmployeeAbsenceTimeEnum.HOURS]: {
      name: $localize`Horas`,
    },
  };
